/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { GcpOrganization } from '../models/GcpOrganization';

export class ConnectGcpOrganizationResponse {
  'gcpOrganization': GcpOrganization;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "gcpOrganization",
      "baseName": "gcpOrganization",
      "type": "GcpOrganization",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ConnectGcpOrganizationResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

